import { cn } from '../lib/cn';

/**
 * Formularfeld-Wrapper: Label oben, Pflicht-Stern rechts, Fehler unter dem Feld
 * in danger-500 (erp-design-guideline.md §6.2 / §8.2).
 */
export interface FormFieldProps {
  label: string;
  htmlFor: string;
  required?: boolean;
  error?: string;
  hint?: string;
  /** Tastenkürzel rechts neben dem Label (z. B. „Alt+K" zum Hinspringen). */
  shortcut?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export function FormField({
  label,
  htmlFor,
  required,
  error,
  hint,
  shortcut,
  children,
  className,
}: FormFieldProps) {
  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      <label htmlFor={htmlFor} className="flex items-center gap-1 text-xs text-muted-foreground">
        <span>{label}</span>
        {required && (
          <span className="text-destructive" aria-hidden>
            *
          </span>
        )}
        {shortcut && (
          <span className="ml-auto" aria-hidden>
            {shortcut}
          </span>
        )}
      </label>
      {children}
      {error ? (
        <p role="alert" className="text-xs text-destructive">
          {error}
        </p>
      ) : hint ? (
        <p className="text-xs text-muted-foreground">{hint}</p>
      ) : null}
    </div>
  );
}
